export const SIGN_IN = '/signin';
export const ACCOUNT = '/account';
export const SIGNUP = '/signup';
export const LANDINGPAGE = '/home';


// WEBPACK FOOTER //
// ./src/constants/routes.js